// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './StateInfoBox.scss';

type Props = {
  image: string;
  titleIntl?: string;
  titleExtra?: string;
  subtitleIntl?: string;
  subtitleExtra?: string;
};

export default class StateInfoBox extends Component<Props> {
  render() {
    const { image, titleIntl, titleExtra, subtitleIntl, subtitleExtra } = this.props;
    return (
      <Fragment>
        <div className={style.stateInfoWrap}>
          <div className={style.imageWrap}>
            <img src={image} alt="state"/>
          </div>
          <div className={style.textWrap}>
            {!!titleIntl && <FormattedMessage id={titleIntl}>{
              txt => <p className={style.title}>{txt} {titleExtra}</p>
            }</FormattedMessage>}
            {!!titleExtra && <p className={style.title}>{titleExtra}</p>}

            {!!subtitleIntl && <FormattedMessage id={subtitleIntl}>{
              txt => <p className={style.subtitle}>{txt} {subtitleExtra}</p>
            }</FormattedMessage>}
            {!!subtitleExtra && <p className={style.subtitle}>{subtitleExtra}</p>}
          </div>
        </div>
        <hr className={style.stateInfoWrapRule}/>
      </Fragment>
    );
  }
}

StateInfoBox.propTypes = {
  image: PropTypes.string.isRequired,
  titleIntl: PropTypes.string,
  titleExtra: PropTypes.string,
  subtitleIntl: PropTypes.string,
  subtitleExtra: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/modules/order/components/StateInfoBox/StateInfoBox.jsx